<template>
    <div :style="{'width': width, 'height':height}">
        <canvas :id="`ks-chart-${_uid}`" ></canvas>
    </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions'; 
import Chart from 'chart.js';
export default {
    /**
        tag
        name: ks-chart
        description: chart component 
    **/
    name: "ks_chart",
    mixins: [checkPermissions],
    props:{
        /**
            attribute
            name: width 
            description: width
        **/
        width:{
            default: '100%'
        },
        /**
            attribute
            name: height 
            description: height
        **/
        height:{
            default: '50vh'
        },
        /**
            attribute
            name: configuration 
            description: object configuration
        **/
        configuration:{
            type:Object,
            required:true
        }
    },
    watch:{
        configuration: function(val, oldval) {
            if(val.type !== oldval.type){
                this.reload();
            }else{
                this.chart.type = val.type?val.type:null;
                this.chart.data = val.data?val.data:{};
                this.chart.options = val.options?val.options:{};
                this.chart.update(0);
            }
        } 
    },
    mounted(){
        this.create();
    },
    methods:{
        reload(){
            this.chart.destroy();
            this.create();
        },
        create(){
            let ctx = document.getElementById(`ks-chart-${this._uid}`);
            this.chart = new Chart(ctx,this.configuration);
        }
    },
    data(){
        return {
            chart: null
        }
    }
}
</script>
<style>
    canvas{
        width: 100% !important;
        height: 100% !important;
    }
</style>